import axios from 'axios';

var init = function () {
  [].slice
    .call(document.getElementsByClassName("js-availability"))
    .map(function (el) {
      var id = el.id;
      var type = el.getAttribute("data-type");
      if (type === "article" || type === "journal" || type === "book") {
        var availabilityDiv = el.querySelector(".js-availability-info");

        axios
          .get("/api/availability/" + id)
          .then(function (response) {
            var checking = el.querySelector(".js-checking");
            checking.classList.toggle("is-hidden");
            var data = response.data;

            var location = el.querySelector(".js-location");
            var locationText = document.createTextNode(data.location);
            location.appendChild(locationText);

            var electronic = el.querySelector(".js-electronic-availability");

            var print = el.querySelector(".js-print-availability");

            if (data.subito) {
              var ao = el.querySelector(".access-options");
              var availabilityAo = el.querySelector(".js-ao-availability");
              var a = document.createElement("a");
              a.href = "/u/" + id + "/subito";
              a.target = "_blank";
              a.textContent = "Subito";
              a.classList.add("button", "is-primary");
              if (availabilityAo) {
                ao.insertBefore(a, availabilityAo);
              } else {
                ao.appendChild(a);
              }
            }

            if (data.available) {
              var availableP = el.querySelector(".js-available");
              availableP.classList.toggle("is-hidden");
              location.classList.toggle("is-hidden");
              if (data.availability) {
                if (data.availability.print) {
                  print.classList.toggle("is-hidden");
                }
                if (data.availability.electronic) {
                  electronic.classList.toggle("is-hidden");
                }
              }
            } else {
              throw "Error";
            }
          })
          .catch(function (error) {
            availabilityDiv.style.display = "none";
          });
      }
    });
};

var otherInit = function () {
  var recordElement = document.querySelector(".js-availability");
  if (!recordElement) {
    return;
  }
  var id = recordElement.id;
  axios
    .get("/api/availability/full/" + id)
    .then(function (response) {
      var fullAvailabilityDiv = document.querySelector(".js-full-availability");
      var ul = fullAvailabilityDiv.querySelector("ul");
      var data = response.data;
      data.forEach(function (item) {
        var li = document.createElement("li");
        var a = document.createElement("a");
        a.href =
          "https://sigel.staatsbibliothek-berlin.de/suche/?isil=" +
          item.id +
          "#sbb-yaz-h2";
        a.textContent = item.name;
        a.target = "_blank";
        li.appendChild(a);
        ul.appendChild(li);
      });
      fullAvailabilityDiv.classList.toggle("is-hidden");
    })
    .catch(function (error) {});
};

window.addEventListener("load", init, false);
window.addEventListener("load", otherInit, false);
